function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}


// faq tabs toggal start

      function togal_tabs (item) {
        item.addEventListener("click", () => {
           toggal_all_tabs(item.getAttribute('data-faq_content'));
        });        
      }
        function toggal_all_tabs(tabs_data){
                let tabs_button = document.querySelectorAll("[data-faq_content]");
                            tabs_button.forEach(b => {
                              if(b.getAttribute('data-faq_content') == tabs_data){
                                if(b.classList.contains('is_open')){
                                   b.classList.remove("is_open");    
                                  }else{
                                   b.classList.add("is_open");
                                  }
                              }else{
                                 b.classList.remove("is_open");
                              }
                              });
                           
              }
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
      tabs_title.forEach(togal_tabs);
}
      faq_taggol();


// faq tabs toggal end


// faq tabs toggal content start
      function tab_mai_mappert(item) {
        item.addEventListener("click", () => {
           toggal_all_tabs_content(item.getAttribute('data-hendles'));
        });        
      }
        function toggal_all_tabs_content(tabs_data){
                let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
                            tabs_content_toggel.forEach(b => {
                              if(b.getAttribute('data-hendles') == tabs_data){
                                   b.classList.add("active");
                                  document.querySelector(b.getAttribute('data-hendles')).style.display = 'block';
                              }else{
                                 b.classList.remove("active");
                                 document.querySelector(b.getAttribute('data-hendles')).style.display = 'none';
                              }
                              });
                           
              }
      let tabs_content  = document.querySelectorAll("[data-hendles]");
      tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
        function image_hide(imag){
             let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
              images_val.forEach(b => {
              if(b.alt == imag){
                b.classList.remove("hidden");
              }else{
                b.classList.add("hidden");
              }
                });
          }
      let main_image = document.querySelector(".header__inline-menu");
     if(main_image){
      let images = main_image.querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);
     }



// recantely product script
    window.theme = window.theme || {};
theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};


theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');
    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
//end 

// collection list start

  var swiper = new Swiper(".collection-list", {
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
    320: {
      slidesPerView: 1
    },
    750: {
      slidesPerView: 3
    }
  }
    });

// end

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 500);
}
ALAcheck();
function customALA() {
var selector = $('.related-slider ul');
  // console.log(selector.length);
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    const swiper = new Swiper('.swiper .grid', {
    loop: true,  
    slidesPerView: 4,
    paginationClickable: true,
    spaceBetween: 16,
    arrow:true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next', // Specifies the element for the next button
      prevEl: '.swiper-button-prev', // Specifies the element for the previous button
    },
            breakpoints: {
    275: {
      slidesPerView: 1,
      spaceBetween:5
    },
    575: {
      slidesPerView: 2,
      spaceBetween:5
    },
    768: {
      slidesPerView: 3,
      spaceBetween:16
    },
    1200: {
      slidesPerView: 4,
      spaceBetween:16
    }
            }
  });
  }  
}


// collection filter start

$(".filter-toggle").click(function(){
  $(".filter-toggle").toggleClass("active");
  $("aside").toggleClass("active");
});

//end

// product page accordian
$(document).ready(function () {
  $(".at-title").click(function () {
    $(this).toggleClass("active").next(".at-tab").slideToggle().parent().siblings().find(".at-tab").slideUp().prev().removeClass("active");
  });
});



 // $(document).on('click','.apply_filter.button',function(){
 //   console.log('hh')
 //    var tag_active_legnth = $('#FacetFiltersForm .filter-form .tag-list li').length;
 //    console.log(tag_active_legnth);
 //    var url = $('#FilterDrawer .apply-filter').attr('data-url');
 //     // for(var i=0;i < tag_active_legnth;i++){
 //     //   if($('#FilterDrawer .filter-form .tag-list li').eq(i).hasClass('tag--active')){
 //     //     var value = $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('value');
 //     //     value = value.replace(/\s+/g, '+');
 //     //     value = value.replace(/\&+/g, '%26');
 //     //     value = value.replace(/\;+/g, '%3B');
 //     //     if(url.includes('?')){
 //     //       var url = url + '&' + $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('name') + '=' + value;
 //     //     }else{
 //     //       var url = url + '?' + $('#FilterDrawer .filter-form .tag-list li').eq(i).find('.tag__input').attr('name') + '=' + value;
 //     //     }
 //     //   }
 //     // }
 //    console.log(url)
 //    // window.location.href = url;
 //  });

// search

$(".header__search  svg").click(function(){
 $("body").addClass("search-open");
});
$(".header__search .modal-overlay , .search-modal__close-button").click(function(){
 $("body").removeClass("search-open");
});